import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import RMGrid from 'core/grid';

import { withRouter } from 'react-router';

import { localeStrings as strings } from 'applicationConfig';
import paths from '../../../common/constants/paths';
import localStorageHelper from 'utils/LocalStorageHelper';

import OrderInfo from './OrderInfo';

@observer
class BaseOrderView extends Component {
  @observable expanded = false;
  @observable orderInfo = {};

  constructor(props) {
    super(props);
    this.toggleMode = this.toggleMode.bind(this);
    this.goBack = this.goBack.bind(this);
    this.orderInfo = { ...this.props.order.data[0], tradeDisplay: !!this.props.tradeDisplay};
  }

  handleRowClick = (value) => {
    if (value) {
      this.updateOrderInfo(value);
    } else {
      console.warn('Invalid order data:', value);
    }
  };

  getLocalStorageKey() {
    return `${this.props.id}_expanded`;
  }

  toggleMode = function() {
    this.expanded = !this.expanded;
    const localStorageKey = this.getLocalStorageKey();
    localStorageHelper.set(localStorageKey, this.expanded);
  };

  componentWillMount() {
    this.expanded = !!localStorageHelper.get(this.getLocalStorageKey());
  }

  @action
  updateOrderInfo(newOrderInfo) {
    this.orderInfo = { ...newOrderInfo, tradeDisplay: !!this.props.tradeDisplay};
  }

  goBack() {
    this.props.history.push(paths.dataSelect);
  }

  render() {
    const showExpandCollapse = this.props.showExpandCollapse;
    // const tradeDisplay = this.props.tradeDisplay;
    // const orderInfo = { ...this.props.order, tradeDisplay: !!this.props.tradeDisplay };
    // const tradeDisplay = this.props.tradeDisplay;

    return (
      <div>
        <div>

          {showExpandCollapse && (
            <div className="actions top-actions">
              <button className="btn btn-primary expand-button" onClick={this.toggleMode}>
                <span className={this.expanded ? 'arrow-right' : 'arrow-left'}>&nbsp;</span>
                <span className="button-caption">{this.expanded ? 'Collapse' : 'Expand'}</span>
                <span className={this.expanded ? 'arrow-left' : 'arrow-right'}>&nbsp;</span>
              </button>
            </div>
          )}
          <div className="order-view-flex">
          <div className="order-info-panel">
          <OrderInfo {...this.orderInfo} />
          </div>
          <div className={`order-grid-wrapper ${(!showExpandCollapse || this.expanded) && 'expanded'} ${'is-small'}`}>
           <RMGrid columns={this.props.gridColumns} rows={this.props.order.data} expanded={this.expanded} onRowClick={this.handleRowClick} />
          </div>
          </div>
        </div>
        <div className="actions">
          <div>
            <button className="btn btn-primary" onClick={this.goBack}>
              <span className="arrow-left">&nbsp;</span>
              <span className="select-instrument">{strings.dataViewing.selectInstrument}</span>
            </button>
          </div>

          <div>
            <button className="btn btn-primary" onClick={this.props.onRefresh}>
              <span className="button-caption">{strings.generic.refresh}</span>
              <span className="arrow-right">&nbsp;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BaseOrderView);



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/BaseOrderView.jsx